import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CollapsibleMapLegend, MapLegendSwatchStyled } from "@ryde/controls";

import { TRACKING_TRAIL_LEGEND_ROWS } from "./tracking-trail-legend.constants";

/**
 * Live-map key mirroring the states the trail renderer draws: planned route (solid), real GPS (dashed),
 * no signal (grey sparse dots — a >2-min gap is interpolated), and detour (red). Rows come from
 * TRACKING_TRAIL_LEGEND_ROWS so the legend stays in sync with the renderer; the collapse behavior is the
 * shared CollapsibleMapLegend.
 */
export const TrackingTrailLegend: FC = () => {
  const { t } = useTranslation();

  return (
    <CollapsibleMapLegend title={t("rideMap.LEGEND_TITLE")}>
      {TRACKING_TRAIL_LEGEND_ROWS.map(row => (
        <span key={row.labelKey} className="map-legend__row">
          <MapLegendSwatchStyled
            $color={row.color}
            $lineStyle={row.swatchStyle}
          />
          {t(row.labelKey)}
        </span>
      ))}
    </CollapsibleMapLegend>
  );
};
